export default __webpack_public_path__ + "static/media/flask.c084b934.svg";